import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

const Content = ({ email, departments, onDepartmentSelect }) => (
  <>
    <div className="remote-access-dialog__text">
      Welcome to Reaxys Choice Screen<br/>
      To log in please select one of the departments below.
    </div>
    {departments &&
    <ul className="remote-access-dialog__departments-list">
      {departments.map(department =>
        <li key={department.departmentId} className="remote-access-dialog__departments-list__item">
          <Button
            buttonConfig={{
              type: 'link',
              size: 'sm',
              label: `${department.accountName}, ${department.departmentName}`,
              labelWrapperClassName: 'remote-access-dialog__departments-list__item__button__label',
              className: 'remote-access-dialog__departments-list__item__button',
              e2eName: 'remote-access-department-choice',
            }}
            iconConfig={{
              name: 'chevron-right',
              size: 'sm',
              className: 'remote-access-dialog__departments-list__item__button__icon',
              position: 'before',
            }}
            onClick={() => {
              onDepartmentSelect(department, email);
            }}
          />
        </li>,
      )}
    </ul>
    }
  </>
);

Content.propTypes = {
  email: PropTypes.string.isRequired,
  departments: PropTypes.array,
  onDepartmentSelect: PropTypes.func.isRequired,
};

export default Content;
